import React from "react";
import styles from "./sobre_mim_cubonetattoo.module.scss";
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const Sobre_mim_cubonetattoo: React.FC = () => {

    return (
        <div className={styles.sobre_mim_cubonetattoo}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/cubonetattoo" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Sobre mim</h1>
            </div>

            {/* CONTEÚDO */}
            <div className={styles.content}>
                <div className={styles.imageContainer}>
                    <img src={require("./src/img_sobremim.png")} alt="Rafael Cubone" />
                </div>
                <h2>Rafael Cubone</h2>
                <p>
                    Com mais de 10 anos de experiência, sou tatuador premiado mais de 30 vezes em convenções e proprietário do estúdio mais completo da região. Especialista em neo tradicional, também desenvolvo trabalhos nos estilos blackwork, preto e cinza, old school, fineline, ornamental, botânico, tribal e cobertura, sempre respeitando a individualidade e essência de cada cliente.
                </p>
                <p>
                    Como artista plástico, grafiteiro e muralista, encontro inspiração na arte nouveau e na anatomia do corpo humano, criando tattoos que se integram perfeitamente à pele. Também sou artista destaque em tatuagem em pele negra, e trabalho com camuflagem de estrias e cicatrizes, elevando a autoestima e confiança de quem passa pelo meu estúdio.
                </p>
                <p>
                    Meu compromisso é com qualidade, dedicação e exclusividade: estudo e me aprofundo constantemente em técnicas e referências para entregar arte única para cada cliente.
                </p>
            </div>

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    <a href="https://wa.me/5517997449691?text=Olá, vim pelo link na bio e gostaria de mais informações..." target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><WhatsappIcon height="30" color="#ffffff" /></div>
                            <span>WhatsApp</span>
                        </div>
                    </a>
                    <a href="https://maps.app.goo.gl/NnYiDFBX8zqoTtnR7" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><MapsIcon height="30" color="#ffffff" /></div>
                            <span>Localização</span>
                        </div>
                    </a>
                    <a href="https://www.instagram.com/cubonetattoo?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}><InstagramIcon height="26" color="#ffffff" /></div>
                            <span>Instagram</span>
                        </div>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Sobre_mim_cubonetattoo;
